import { connect } from 'react-redux'
import MaintenanceRfidComponent from '../components/MaintenanceRfidComponent.jsx';
import {
	forwardToShowRfidConfig,
	forwardToHideRfidConfig,
	forwardToAssignRfidReader,
	forwardToReadRfidChips,
	forwardToCleanRfidChips,
	forwardToMarkAsNotKKProduct,
	forwardToMarkAsNoEpc,
	forwardToAssignEpcTag,
	forwardToAssignEpcTagByLabelId,
	forwardToReloadCurrentEpc,
	forwardToCleanAlert,
	forwardChangeCheckCardLabelId,
	forwardShowInputLabelId,
	findSearchMRecordList,
	closeSearchMRecordModal,
	cleanSearchMRecordList,
} from '../actions';

const mapStateToProps = (state) => ({
	alert: state.getIn(['checkCardReducer', 'alert']),
	view: state.getIn(['checkCardReducer', 'view']),
	request: state.getIn(['checkCardReducer', 'request']),
	rfid: state.getIn(['checkCardReducer', 'rfid']),
	isLoadingChipEpcs: state.getIn(['checkCardReducer', 'isLoadingChipEpcs']),
	labelId: state.getIn(['checkCardReducer', 'labelId']),
	showInputLabelId: state.getIn(['checkCardReducer', 'showInputLabelId']),

	previous: state.getIn(['maintenanceCardsReducer', 'mCardListRequestModel']),
	previousView: state.getIn(['maintenanceCardsReducer', 'mCardListViewModel']),
	cases: state.getIn(['maintenanceCasesReducer', 'mCaseListRequestModel']),

	showModal: state.getIn(['maintenanceSearchReducer', 'showModal']),
	mRecordList: state.getIn(['searchMRecordListReducer', 'searchMRecordList']),
})

const mapDispatchToProps = (dispatch) => ({
	showRfidConfig: () =>{
		dispatch(forwardToShowRfidConfig());
	},

	hideRfidConfig: () =>{
		dispatch(forwardToHideRfidConfig());
	},

	assignRfidReader: (speedway) =>{
		dispatch(forwardToAssignRfidReader(speedway));
	},

	readRfidChips: (speedway) => {
		dispatch(forwardToReadRfidChips(speedway));
	},

	cleanRfidChips: () => {
		dispatch(forwardToCleanRfidChips());
	},

	markAsNotKKProduct:(catCode, card ,operator)=> {
		dispatch(forwardToMarkAsNotKKProduct(catCode, card ,operator));
	},

	markAsNoEpc:(catCode, card ,operator)=> {
		dispatch(forwardToMarkAsNoEpc(catCode, card ,operator));
	},

	assignEpcTag:(catCode, card, epc ,operator) => {
		dispatch(forwardToAssignEpcTag(catCode, card, epc ,operator));
	},

	assignEpcTagByLabelId:(catCode, card, labelId ,operator) => {
		dispatch(forwardToAssignEpcTagByLabelId(catCode, card, labelId ,operator));
	},

	reloadCurrentEpc: (card, catCode) => {
		dispatch(forwardToReloadCurrentEpc(card, catCode));
	},

	cleanAlert: () => {
		dispatch(forwardToCleanAlert());
	},

	changeLabelId: (labelId) => {
		dispatch(forwardChangeCheckCardLabelId(labelId));
	},

	changeShowInputLabelId: (show) => {
		dispatch(forwardShowInputLabelId(show));
	},

	findMRecordList: (epc) => {
		dispatch(findSearchMRecordList(epc));
	},

	closeModal: () => {
		dispatch(closeSearchMRecordModal());
	},

	cleanSearchResult: () => {
		dispatch(cleanSearchMRecordList());
	},
})

const MaintenanceRfidContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(MaintenanceRfidComponent)

export default MaintenanceRfidContainer;


// WEBPACK FOOTER //
// ./src/containers/MaintenanceRfidContainer.jsx